import {IntegrationsPageLayout} from '../../../_gori/layout/components/IntegrationsPagesLayout'

export function WooCommerceIntegration() {
  return (
    <>
      <IntegrationsPageLayout
        pageClass='woocommerce-integration'
        integrationLogo='/media/gori/integrations/woocommerce/woocommerce-logo.svg'
        integrationLogoAlt='woocommerce-logo'
        integrateImg='/media/gori/integrations/woocommerce/integrate.webp'
        card1Copy='WOOCOMMERCE_CARD_1'
        card2Copy='WOOCOMMERCE_CARD_2'
        card3Copy='WOOCOMMERCE_CARD_3'
        card4Copy='WOOCOMMERCE_CARD_4'
        store='WooCommerce'
      />
    </>
  )
}
